<template>
<svg viewBox="0 0 13 12" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-Nan`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.4219 1.46343C10.37 1.45424 10.317 1.45263 10.2648 1.45861L8.1788 1.46143C7.88992 1.46182 7.65605 1.69632 7.65644 1.9852C7.65683 2.27408 7.89133 2.50795 8.18022 2.50756L9.0446 2.50639L7.73378 3.80859C7.03533 3.14925 6.09342 2.74505 5.0571 2.74505C2.90319 2.74505 1.1571 4.49114 1.1571 6.64505C1.1571 8.79896 2.90319 10.545 5.0571 10.545C7.21102 10.545 8.9571 8.79896 8.9571 6.64505C8.9571 5.9209 8.75974 5.24285 8.41587 4.66175L9.86096 3.22616L9.86143 4.01669C9.8616 4.29427 10.0868 4.51916 10.3643 4.51899C10.6419 4.51882 10.8668 4.29366 10.8666 4.01609L10.8655 2.06622C10.8719 2.01486 10.871 1.96275 10.8628 1.91159C10.8392 1.67741 10.6549 1.49071 10.4219 1.46343ZM7.82143 6.67422C7.82143 8.193 6.59022 9.42422 5.07143 9.42422C3.55265 9.42422 2.32143 8.193 2.32143 6.67422C2.32143 5.15544 3.55265 3.92422 5.07143 3.92422C6.59022 3.92422 7.82143 5.15544 7.82143 6.67422Z" :fill="useCurrentColor ? 'currentColor' : '#3681EE'"/></svg>
</template>
<script>

export default {
  name: 'IconNan',
  props: {
    prefix: {
        type: String,
        default: 'LAIDO',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
